import styled from "styled-components";
import React, { useRef } from "react";
import * as api from '../../api';
import H2 from "../Atoms/H2";
import { useTranslation } from 'react-i18next';
import Input from "../Atoms/Input";
import Select from "../Atoms/Select";
import CheckboxPublicPrivate from "../Atoms/CheckboxPublicPrivate";
import H1 from "../Atoms/H1";
import Textarea from "../Atoms/Textarea";
import ImageUpload from "../Atoms/ImageUpload";
import Popup from "../Atoms/Popup";
import { useNavigate } from "react-router-dom";
import Section from "../Atoms/Section";
import { typologiesEspace, typologiesObjet } from "../Utils/Listings";
import BlueButton from "../Atoms/BlueButton";
import Spinner from "../../Plateforme/Atoms/Spinner";
import MiniatureContainer from "../Atoms/MiniatureContainer";
import PressLinksDisplay from "../Atoms/PressLinksDisplay";
import PressLinksAdd from "../Atoms/PressLinksAdd";
import AwardsDisplay from "../Atoms/AwardsDisplay";
import AwardsAdd from "../Atoms/AwardsAdd";
import { cat_gories_viaContainsVIACategory, validateFrom } from "../Utils/Validator";
import UploadProgressBar from "../Atoms/UploadProgressBar";
import H0 from "../Atoms/H0";
import AdressInput from "../Atoms/AdressInput";

const MyProject = (props) => {

    const [user, setUser] = React.useState({});
    const [project, setProject] = React.useState({});
    const [type, setType] = React.useState("objet");
    const [typologie, setTypologie] = React.useState("");
    const [pressLinks, setPressLinks] = React.useState("");
    const [awards, setAwards] = React.useState("");
    const [newMedias, setNewMedias] = React.useState([]);
    const [mediasToDelete, setMediasToDelete] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [libreEdition, setLibreEdition] = React.useState(false);
    const [uploadProgress, setUploadProgress] = React.useState(0);
    const { i18n } = useTranslation('common');
    const navigate = useNavigate();

    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');
    const as = urlParams.get('as');
    const cid = urlParams.get('cid');

    React.useEffect(() => {
        setLoading(true);
        if(props.fullUserLoading) return;
        if(!props.fullUser?.user) navigate("/");
        if(props.fullUser?.user && props.fullUser.user.role === "admin" && as){
            getProfile()
        }else{
            setUser(props.fullUser);
            const currentProject = props.fullUser?.company?.projects && props.fullUser?.company.projects?.find((project) => project._id === id);
            if(currentProject){
                setProject(currentProject);
                setType(currentProject.type || "objet");
                setTypologie(currentProject.typologie || "");
                setLibreEdition(currentProject.libre_edition || "oui");
                setPressLinks(currentProject.lien_presse || "");
                setAwards(currentProject.awards || "");
            }
            setLoading(false);
        }
    }, [props.fullUserLoading, props.fullUser, id, as]);

    function getProfile(){
        setLoading(true);
        setNewMedias([]);
        setMediasToDelete([]);
        api.GetAllUserData({email : atob(as), companyId: cid || undefined}).then((response) => {
            setUser(response.data);
            const currentProject = response.data?.company?.projects && response.data?.company.projects?.find((project) => project._id === id);
            if(currentProject){
                setProject(currentProject);
                setType(currentProject.type || "objet");
                setTypologie(currentProject.typologie || "");
                setLibreEdition(currentProject.libre_edition || "oui");
                setPressLinks(currentProject.lien_presse || "");
                setAwards(currentProject.awards || "");
            }
            setLoading(false);
        }).catch((error) => {
            console.log(error);
        })
    }

    if(loading || props.fullUserLoading || !user){
        return (
            <>
                <br/><br/><br/>
                <Spinner/>
                <br/>
                <UploadProgressBar uploadProgress={uploadProgress}/>
            </>
        )
    }

    function viewInPublicMode(event){
        event.preventDefault();
        navigate('/project?pid=' + project._id + '&cid=' + user.company._id);
    }

    function onUploadProgress(progressEvent){
        const percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        setUploadProgress(percentCompleted);
    }

    async function handleSubmit(event) {
        event.preventDefault();
        setLoading(true);
        const submission = new FormData(event.target);
        if(!validateFrom(submission)) return;
        submission.append('projectid', id);
        submission.append('companyid', user?.company._id);
        submission.append('newMedias', JSON.stringify(newMedias.map((media,i) => {return {fileIndex:i,fileName:media.file.name,credit:media.credit,legende:media.legende}})));
        submission.append('mediasToDelete', JSON.stringify(mediasToDelete));
        for(let i = 0; i < newMedias.length; i++){
            submission.append('file_'+i, newMedias[i].file);
        }
        
        api.UpdateProject(submission, onUploadProgress).then((response) => {
            props.refreshUser();
            if(response.data === "file too big"){
                setLoading(false);
                alert(i18n.language === "fr" ? "Un fichier est trop volumineux." : "A file is too big.");
                return;
            }
            if(as){
                if(id){
                    getProfile()
                }else{
                    navigate('/mycompany?id=' + as);
                }
            }else{
                navigate('/mycompany');
            }
        }).catch((error) => {
            console.log(error);
        })
    }

    function removeNewMedia(media){
        setNewMedias(newMedias.filter((_media) => _media !== media));
    }

    function removeOldMedia(media){
        setProject({...project, medias:project.medias.filter((_media) => _media !== media)});
        setMediasToDelete([...mediasToDelete, media.path]);
    }

    function deleteProject(e){
        e.preventDefault();
        if(window.confirm(i18n.language === "fr" ? "Êtes-vous sûr de vouloir supprimer ce projet ?" : "Are you sure you want to delete this project ?")){
            setLoading(true);
            api.DeleteProject({projectid:id, companyid:user.company._id}).then((response) => {
                props.refreshUser();
                // if(id){
                //     // if(id){
                //     //     getProfile()
                //     // }else{
                //         navigate('/mycompany?id=' + as);
                //     // }
                // }else{
                //     navigate('/mycompany');
                // }
                navigate('/mycompany');
            }).catch((error) => {
                console.log(error);
            })
        }
    }

    return (
        <form onSubmit={event => handleSubmit(event)}>
            <Section className="padding flexblock" style={{alignItems:'center'}}>
                <H0 style={{width:'calc(100% - 350px)'}}><Input style={{width:'100%',fontSize:'35px',fontWeight:'600'}} name="name" required placeholder={i18n.language === "fr" ? "Nom du projet" : "Project name"} defaultValue={project.name?.toUpperCase() || ''}/></H0>
                {id && cat_gories_viaContainsVIACategory(user.hsProfile?.properties?.cat_gories_via) && <BlueButton onClick={event => viewInPublicMode(event)}><img src='/img/fleche_blanche.png' alt='' />{i18n.language === "fr" ? "Aperçu en mode public" : "Preview in public mode"}</BlueButton>}
            </Section>
            <Section className="flexblock">
                <div>
                    <br/>
                    <div className="flexblock">
                        <span>{i18n.language === "fr" ? "Type de projet" : "Project type"}</span><br/>
                        <Select name="type" style={{width:"100%"}} value={type} onChange={(event) => setType(event.target.value)}>
                            <option value="objet">{i18n.language === "fr" ? "Objet" : "Object"}</option>
                            <option value="espace">{i18n.language === "fr" ? "Espace" : "Space"}</option>
                        </Select>
                    </div><br/>
                    <div className="flexblock">
                        <span>{i18n.language === "fr" ? "Typologie" : "Typology"}</span><br/>
                        <Select name="typologie" style={{width:"100%"}} value={typologie} onChange={(event) => setTypologie(event.target.value)}>
                            {type === "objet" && typologiesObjet.map((typologie) => {
                                return <option key={typologie.code} value={typologie.code}>{i18n.language === "fr" ? typologie.fr : typologie.en}</option>
                            })}
                            {type === "espace" && typologiesEspace.map((typologie) => {
                                return <option key={typologie.code} value={typologie.code}>{i18n.language === "fr" ? typologie.fr : typologie.en}</option>
                            })}
                        </Select>
                        {typologie === "autre" && 
                            <Input required name="autre_typologie" style={{width:"100%"}} placeholder={i18n.language === "fr" ? "Veuillez préciser" : "Please specify"}  defaultValue={project?.autre_typologie}/>
                        }
                    </div><br/>
                </div>
                <div>
                    <br/>
                    <div className="flexblock">
                        <span>{i18n.language === "fr" ? "Année de livraison du projet" : "Project delivery year"}</span><br/>
                        <Input name="year" type="number" style={{width:"100%"}} required placeholder={i18n.language === "fr" ? "Année de livraison du projet" : "Project delivery year"}  defaultValue={project.year}/>
                    </div><br/>
                    <div className="flexblock" style={{marginTop:"20px"}}>
                        <span>{i18n.language === "fr" ? "Projet privé ou public :" : "Private or public project :"}</span><br/>
                        <CheckboxPublicPrivate name="public" defaultChecked={project.public}/>
                    </div><br/>
                    <br/>
                </div>
            </Section>
            {type === "objet" && <Section className="flexblock">
                <div>
                    <br/>
                    <Input name="fabricant" style={{width:"100%"}} placeholder={i18n.language === "fr" ? "Fabricant/artisan" : "Manufacturer/craftsman"}  defaultValue={project?.fabricant}/><br/><br/>
                    <div className="flexblock">
                        <span>{i18n.language === "fr" ? "Le projet fait-il appel à la fabrication Française ?" : "Does the project use French manufacturing?"}</span><br/>
                        <Select name="fabrication_fr" style={{width:"100%"}} defaultValue={project?.fabrication_fr}>
                            <option value="oui">{i18n.language === "fr" ? "Oui" : "Yes"}</option>
                            <option value="non">{i18n.language === "fr" ? "Non" : "No"}</option>
                        </Select>
                    </div><br/>
                    {/* fabrication française précision<br/><br/> */}
                </div>
                <div>
                    <br/>
                    <Input name="galerie" style={{width:"100%"}} placeholder={i18n.language === "fr" ? "Galerie" : "Gallery"}  defaultValue={project?.galerie}/><br/><br/>
                    <div className="flexblock">
                        <span>{i18n.language === "fr" ? "Le projet est-il libre à l'édition ?" : "Is the project free to edit?"}</span><br/>
                        <Select name="libre_edition" style={{width:"100%"}} value={libreEdition} onChange={(event) => setLibreEdition(event.target.value)}>
                            <option value="oui">{i18n.language === "fr" ? "Oui" : "Yes"}</option>
                            <option value="non">{i18n.language === "fr" ? "Non" : "No"}</option>
                        </Select>
                    </div><br/>
                   {libreEdition === "non" && <Input name="editeur" style={{width:"100%"}} placeholder={i18n.language === "fr" ? "Editeur" : "Editor"}  defaultValue={project?.editeur}/>}
                </div>
            </Section>}
            {type === "espace" && <Section className="flexblock">
                <div>
                    {/* <br/><Input name="adresse" required style={{width:"100%"}} placeholder={i18n.language === "fr" ? "Adresse du projet" : "Project address"} defaultValue={project?.adresse}/><br/><br/> */}
                    <AdressInput 
                        adressDefaultValue={project?.adresse}
                        latitudeDefaultValue={project?.latitude}
                        longitudeDefaultValue={project?.longitude}
                        required
                        placeholder={i18n.language === "fr" ? "Adresse du projet" : "Project address"}
                        adressInputName="adresse"
                        latitutdeInputName="latitude"
                        longitudeInputName="longitude"
                    />
                </div>
                <div>
                    <div className="flexblock">
                        <span>{i18n.language === "fr" ? "Le projet fait-il appel à la fabrication Française ?" : "Does the project use French manufacturing?"}</span><br/>
                        <Select name="fabrication_fr" style={{width:"100%"}} defaultValue={project?.fabrication_fr}>
                            <option value="oui">{i18n.language === "fr" ? "Oui" : "Yes"}</option>
                            <option value="non">{i18n.language === "fr" ? "Non" : "No"}</option>
                        </Select>
                    </div>
                    {/* fabrication française précision<br/><br/> */}
                </div>
            </Section>}
            <Section className="flexblock">
                <div>
                    <div className="flexblock">
                        {type === "objet" && 
                            <Input name="client" style={{width:"100%"}} placeholder={i18n.language === "fr" ? "Client / Commenditaire / Distributeur" : "Client / Commisioner / Distributor"} defaultValue={project?.client}/>
                        }
                        {type === "espace" &&
                            <Input name="client" style={{width:"100%"}} placeholder={i18n.language === "fr" ? "Client / Commenditaire" : "Client / Commisioner"} defaultValue={project?.client}/>
                        }
                        <CheckboxPublicPrivate name="showclient" defaultChecked={project.showclient}/>
                    </div><br/>
                    {/* <Input name="lien_presse" style={{width:"100%"}} placeholder={i18n.language === "fr" ? "Lien presse" : "Press link"}  defaultValue={project?.lien_presse}/><br/><br/> */}
                    <PressLinksDisplay
                        inputName="lien_presse"
                        pressLinks={pressLinks}
                        setPressLinks={setPressLinks}
                    />
                    <br/>
                    <PressLinksAdd
                        pressLinks={pressLinks}
                        setPressLinks={setPressLinks}
                    />
                </div>
                <div>
                    <AwardsDisplay
                        inputName="awards"
                        awards={awards}
                        setAwards={setAwards}
                    />
                    <br/>
                    <AwardsAdd
                        awards={awards}
                        setAwards={setAwards}
                    />
                </div>
            </Section>
            <Section className="padding">
                <H2>{i18n.language === "fr" ? "Présentation du projet" : "Project presentation"}</H2><br/><br/>
                <span>{i18n.language === "fr" ? "Français" : "French"}</span><br/>
                <Textarea name="aboutfr" style={{width:"100%"}} placeholder={i18n.language === "fr" ? "Présentation du projet" : "Project presentation"}  defaultValue={project?.aboutfr}/><br/><br/>
                <span>{i18n.language === "fr" ? "Anglais" : "English"}</span><br/>
                <Textarea name="abouten" style={{width:"100%"}} placeholder={i18n.language === "fr" ? "Présentation du projet" : "Project presentation"}  defaultValue={project?.abouten}/><br/><br/>
            </Section>
            <Section className="padding">
                <H2>{i18n.language === "fr" ? "Médias" : "Medias"}</H2><br/><br/>
                <MiniatureContainer>
                    <AddMedia
                        medias={newMedias}
                        setMedias={setNewMedias}
                    />
                    {newMedias.map((media,index) => {
                        return (
                            <MediaPreview key={index} media={media} newMedia removeMedia={removeNewMedia}/>
                        )
                    })}
                    {project.medias && project.medias.map((media,index) => {
                        return (
                            <MediaPreview key={media.path} media={media} removeMedia={removeOldMedia}/>
                        )
                    })}
                </MiniatureContainer>
            </Section>
            <Section className="padding">
                <BlueButton className="centered"><img src='/img/fleche_blanche.png' alt='' />{i18n.language === "fr" ? "Enregistrer" : "Save"}</BlueButton>
            </Section>
            <Section className="padding">
                <BlueButton onClick={deleteProject} className="centered" style={{backgroundColor:'red'}}>{i18n.language === "fr" ? "Supprimer" : "Delete"}</BlueButton>
            </Section>
        </form>
    );
};

const FileContainer = styled.div`
    width: 400px;

    @media (max-width: 1000px) {
        width: 300px;
    }

    .mainMedia {
        width: 100%;
        height: 400px;
        border: 1px solid black;
        display: flex;
        justify-content: center;
        align-items: center;
        position : relative;

        @media (max-width: 1000px) {
            height: 300px;
        }

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

        video {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

        .remove_cross{
            position: absolute;
            top: 10px;
            right: 10px;
            background-color: red;
            color: white;
            font-size: 20px;
            border-radius: 100px;
            padding: 2px 7px;
            opacity: 0;
            cursor: pointer;
            z-index: 2;
        }

        &:hover .remove_cross {
            opacity: 0.5;

            &:hover {
                opacity: 1;
            }
        }
    }

    .addMedia {
        width: 100%;
        height: 400px;

        @media (max-width: 1000px) {
            height: 300px;
        }

        background-image: linear-gradient(#fff, #bbb);
        cursor: pointer;
        color: white;
        
        div {
            padding: 40px;
            display: flex;
            justify-content: center;
            align-items: end;
            height: 100%;
            background-image: url('/img/croix_blanche.png');
            background-repeat: no-repeat;
            background-position: center;
            background-size: 30px;
        }
    }
`

const MediaPreview = (props) => {

    const { i18n } = useTranslation('common');

    let file = {}
    if(props.newMedia)
        file = props.media.file;
    else
        file = props.media;

    if(!file || !file.type) return null;

    let fullPath = '';
    let fileName = '';
    let credit = '';
    let legende = '';
    if(props.newMedia){
        fullPath = URL.createObjectURL(file);
        fileName = file.name;
        credit = props.media.credit;
        legende = props.media.legende;
    }else{
        fullPath = process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + file.path;
        fileName = file.fileName;
        credit = file.credit;
        legende = file.legende;
    }

    function removeMedia(){
       props.removeMedia(props.media);
    }

    return (
        <FileContainer>
            <div className="mainMedia">
                <span className="remove_cross" onClick={removeMedia}>✕</span>
                {file.type.includes('image') && <img src={fullPath} alt={fileName}/>}
                {file.type.includes('video') && <video controls >
                    <source src={fullPath} type={file.type}/>
                </video>}
                {file.type.includes('pdf') &&  <a href={fullPath} target="_blank" rel="noreferrer">{i18n.language === "fr" ? "Voir le PDF" : "See PDF"}</a>}
            </div>
            <br/>
            <i>{fileName}</i><br/><br/>
            <span>{i18n.language === "fr" ? "Credit" : "Copyright"} : <span>{credit}</span></span><br/>
            <span>{i18n.language === "fr" ? "Légende" : "Caption"} : <span>{legende}</span></span><br/>
        </FileContainer>
    )
}

const AddMedia = (props) => {

    const { i18n } = useTranslation('common');
    const [popupOpen, setPopupOpen] = React.useState(false);
    const [currentFile, setCurrentFile] = React.useState(null);
    const [credit, setCredit] = React.useState('');
    const [legende, setLegende] = React.useState('');
    const fileInputRef = useRef(null);

    const handleInputChange = (event) => {

        if(event.target.files[0].size > 50000000){
            alert(i18n.language === "fr" ? "Le fichier est trop lourd. Veuillez sélectionner un fichier de moins de 50Mo." : "The file is too heavy. Please select a file under 50Mb.");
            return;
        }

        setCurrentFile(event.target.files[0]);
    };

    const handleAddFile = (event) => {
        event.preventDefault();
        if (fileInputRef.current) {
            fileInputRef.current.click(); // Trigger the file selection popup
        }
    };

    const changeCreditInput = (event) => {
        setCredit(event.target.value);
    };

    const changeLegendeInput = (event) => {
        setLegende(event.target.value);
    }

    function addMedia(event){
        event.preventDefault();
        setPopupOpen(false);
        props.setMedias([...props.medias, {file:currentFile,credit,legende}]);
        setCurrentFile(null);
        setCredit('');
        setLegende('');

        //aslo clear the input
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    }

    return (
        <>
            <FileContainer>
                <div style={{cursor:"pointer"}} onClick={() => setPopupOpen(true)} className="addMedia">
                    <div>{i18n.language === 'fr' ? "Ajouter un média" : "Add a media"}</div>
                </div>
                <input hidden type='file' accept="application/pdf, image/png, image/jpeg, video/mp4, video/quicktime" onChange={handleInputChange} ref={fileInputRef}/>
                <input hidden readOnly value={credit}/>
                <input hidden readOnly value={legende}/>
                {popupOpen &&
                    <Popup close={() => setPopupOpen(false)}>
                        {currentFile ? (
                            <>
                                <span>{i18n.language === 'fr' ? ("Fichier sélectionnée :") : ("Selected file:")}</span><br/>
                                <span><a href={URL.createObjectURL(currentFile)} target="_blank" rel="noreferrer">{i18n.language === 'fr' ? 'Voir le fichier' : 'View file'}</a></span><br/>
                                <button onClick={event => handleAddFile(event)}>{i18n.language === 'fr' ? 'Sélectionner un autre fichier' : 'Select another file'}</button><br/>
                            </>
                        ) : (
                            <>
                                <span>{i18n.language === 'fr' ? ("Pas de fichier sélectionné.") : ("No file selected.")}</span><br/>
                                <button onClick={event => handleAddFile(event)}>{i18n.language === 'fr' ? 'Sélectionner un fichier' : 'Select a file'}</button><br/>
                            </>      
                        )}
                        <span className='thin'>{i18n.language === "fr" ? "(.mp4, .pdf, .png, .jpg ou .jpeg, 50Mo maximum)" : "(.mp4, .pdf, .png, .jpg or .jpeg, 50Mb maximum)"}</span><br/>
                        <Input style={{width:"100%"}} required onChange={changeCreditInput} placeholder={i18n.language === "fr" ? "Crédit" : "Copyright"} defaultValue={credit} /><br/>
                        <Input style={{width:"100%"}} onChange={changeLegendeInput} placeholder={i18n.language === "fr" ? "Légende" : "Caption"} defaultValue={legende} /><br/>
                        {currentFile && <button onClick={addMedia}>{i18n.language === 'fr' ? 'Ajouter' : 'Add'}</button>}
                    </Popup>
                }
            </FileContainer>
        </>
    )
}

export default MyProject;